import * as React from 'react';
import Animated, { Extrapolation, interpolate, useAnimatedStyle, } from 'react-native-reanimated';
import { StyleSheet } from 'react-native';
import TrustStoryItem from 'login/firstscreen/storyCarouselCards/TrustStoryItem';
import { rem } from 'design-system';
const EachUserDeckView = ({ info, index, source, lastName, firstName, progressSharedValue, largeVerticalPadding, darkBackground, }) => {
    const animatedStyles = useAnimatedStyle(() => ({
        opacity: interpolate(progressSharedValue.value, [index - 1.1, index - 0.9, index - 0.8, index + 0.1, index + 0.25], [0, 0.2, 1, 1, 0], Extrapolation.CLAMP),
        transform: [
            {
                translateY: interpolate(progressSharedValue.value, [index - 0.9, index - 0.75, index - 0.65, index - 0.59], [0, -36, -36, -32], Extrapolation.CLAMP),
            },
        ],
    }), [index, progressSharedValue]);
    return (<Animated.View style={[styles.container, { zIndex: 100 - index }, animatedStyles]}>
      <TrustStoryItem fullWidth info={info} source={source} lastName={lastName} firstName={firstName} largeVerticalPadding={largeVerticalPadding} darkBackground={darkBackground}/>
    </Animated.View>);
};
export default React.memo(EachUserDeckView);
const styles = StyleSheet.create({
    container: {
        bottom: 0,
        left: rem(16),
        right: rem(16),
        position: 'absolute',
    },
});
